import React from 'react';
import { AfterSubmitFunc, Button, ButtonColor, IconType } from 'ui-builder';
import BaseTasksGroupAdminForm from './BaseTasksGroupAdminForm';
import { TasksGroupRequest, useTasksGroupsAdminService } from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';

export function CreateTasksGroupAdminForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const tasksGroupsAdminService = useTasksGroupsAdminService();

  return (
    <BaseTasksGroupAdminForm
      submitFormFunc={async (data: TasksGroupRequest) => {
        return await tasksGroupsAdminService.createTasksGroup(data);
      }}
      title="Create Tasks Group"
      afterSubmitFunc={props.afterSubmitFunc}
    />
  );
}

export function CreateTasksGroupAdminButton() {
  const popupManager = usePopupFormManager();

  return (
    <Button
      onClick={() => {
        popupManager.openForm(<CreateTasksGroupAdminForm />)
      }}
      iconType={IconType.PLUS}
      text="Create Group"
      color={ButtonColor.BLUE}
      isFilled
    />
  );
} 